import { action } from 'mobx';
import { InsuranceOrderingUploadForm } from 'application/insurance-ordering/forms';
import { BaseEditViewStore } from 'core/stores';
import {applicationContext, getErrorMessage} from 'core/utils';
import { InsuranceService } from 'application/import-reference/services';

@applicationContext
class InsuranceOrderingUploadViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const service = new InsuranceService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'file',
            Form: InsuranceOrderingUploadForm,
            actions: () => {
                return {
                    create: async () => {
                        var file = this.form.fields.get("file").files[0];
                        await service.upload({file: file});
                    }
                }
            },
            FormClass: InsuranceOrderingUploadForm,
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success('Insurance upload updated successfully.'), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(getErrorMessage(err, 'Error occured while trying to upload the insurance ordering.'));
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default InsuranceOrderingUploadViewStore;
